import {SET_PRODUCT} from './actionTypes';

export const setProduct = (productName) => {
  let productId;
  if (productName === 'admin') {
    productId = 1;
  } else if (productName === 'teacher') {
    productId = 2;
  } else if (productName === 'fleet') {
    productId = 3;
  } else if (productName === 'director') {
    productId = 4;
  }
  return {
    type: SET_PRODUCT,
    state: productId
  }
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/setProduct.js
 **/